export default __webpack_public_path__ + "static/media/upload-icon.fb901478.svg";